/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Daylist } from './Daylist';
import {
    DaylistFromJSON,
    DaylistFromJSONTyped,
    DaylistToJSON,
    DaylistToJSONTyped,
} from './Daylist';
import type { ShipExpected } from './ShipExpected';
import {
    ShipExpectedFromJSON,
    ShipExpectedFromJSONTyped,
    ShipExpectedToJSON,
    ShipExpectedToJSONTyped,
} from './ShipExpected';

/**
 * 
 * @export
 * @interface ShipExpecteds
 */
export interface ShipExpecteds {
    /**
     * 
     * @type {number}
     * @memberof ShipExpecteds
     */
    datacount: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShipExpecteds
     */
    maxcount: number | null;
    /**
     * 
     * @type {Date}
     * @memberof ShipExpecteds
     */
    lastUpdateDatetime: Date | null;
    /**
     * 
     * @type {Array<ShipExpected>}
     * @memberof ShipExpecteds
     */
    list: Array<ShipExpected>;
    /**
     * 
     * @type {Array<Daylist>}
     * @memberof ShipExpecteds
     */
    daylist: Array<Daylist>;
}

/**
 * Check if a given object implements the ShipExpecteds interface.
 */
export function instanceOfShipExpecteds(value: object): value is ShipExpecteds {
    if (!('datacount' in value) || value['datacount'] === undefined) return false;
    if (!('maxcount' in value) || value['maxcount'] === undefined) return false;
    if (!('lastUpdateDatetime' in value) || value['lastUpdateDatetime'] === undefined) return false;
    if (!('list' in value) || value['list'] === undefined) return false;
    if (!('daylist' in value) || value['daylist'] === undefined) return false;
    return true;
}

export function ShipExpectedsFromJSON(json: any): ShipExpecteds {
    return ShipExpectedsFromJSONTyped(json, false);
}

export function ShipExpectedsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipExpecteds {
    if (json == null) {
        return json;
    }
    return {
        
        'datacount': json['datacount'],
        'maxcount': json['maxcount'],
        'lastUpdateDatetime': (json['last_update_datetime'] == null ? null : new Date(json['last_update_datetime'])),
        'list': ((json['list'] as Array<any>).map(ShipExpectedFromJSON)),
        'daylist': ((json['daylist'] as Array<any>).map(DaylistFromJSON)),
    };
}

export function ShipExpectedsToJSON(json: any): ShipExpecteds {
    return ShipExpectedsToJSONTyped(json, false);
}

export function ShipExpectedsToJSONTyped(value?: ShipExpecteds | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'datacount': value['datacount'],
        'maxcount': value['maxcount'],
        'last_update_datetime': value['lastUpdateDatetime'] == null ? value['lastUpdateDatetime'] : value['lastUpdateDatetime'].toISOString(),
        'list': ((value['list'] as Array<any>).map(ShipExpectedToJSON)),
        'daylist': ((value['daylist'] as Array<any>).map(DaylistToJSON)),
    };
}

